import { render } from "./WQaddlook.vue?vue&type=template&id=0d9cc9b5&scoped=true"
import script from "./WQaddlook.vue?vue&type=script&lang=js"
export * from "./WQaddlook.vue?vue&type=script&lang=js"

import "./WQaddlook.vue?vue&type=style&index=0&id=0d9cc9b5&lang=scss&scoped=true"
import "./WQaddlook.vue?vue&type=style&index=1&id=0d9cc9b5&scoped=true&lang=css"

import exportComponent from "D:\\workCode\\PC\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d9cc9b5"]])

export default __exports__